/**
 * Etiquetas de UI de los roles del backoffice.
 *
 * El contrato (`x-goelectric-roles`) expone valores de API; estos son los nombres
 * legibles. Mismo patrón que el semáforo NOC (`status/station-status.ts`): la
 * traducción de un enum de dominio a texto visible pertenece al design system.
 */
import type { AdminRole } from '@goelectric/shared-types';

export const ROLE_LABELS: Record<AdminRole, string> = {
  SUPER_ADMIN: 'SuperAdmin',
  SOPORTE_N3: 'Soporte N3',
  MARKETING: 'Marketing',
  ALIADO_ADMIN: 'Administrador del aliado',
  CONTADOR: 'Contador',
};
